 import React from "react";
 import { ControlLabel, FormControl, FormGroup } from "react-bootstrap";
 import locale from "locale";
import * as constants from '../constants';
import {PROGRAM_TIME_INTERVALS} from "../../../PagesSettings/pages/ProgramsConstructorPage/constants";
import CPSettingToggle from "../../../../UI/Settings/CPSettingToggle";
import CPSettingSize from "../../../../UI/Settings/CPSettingSize";

const CardViewTile = ({settings, onChange}) => {
    return (
        <>
            <FormGroup controlId="formControlsSelect">
                <ControlLabel style={{fontWeight: 'normal'}}>
                    {locale('program.settings.timelines')}
                </ControlLabel>
                <FormControl
                    value={settings?.[constants.SCHEDULE_TILE_INTERVALS]}
                    componentClass="select"
                    placeholder="select"
                    onChange={(e) => onChange({[constants.SCHEDULE_TILE_INTERVALS]: e.target.value})}
                >
                    {
                        PROGRAM_TIME_INTERVALS.map((timeInterval) => (
                            <option key={timeInterval} value={timeInterval}>
                                {!!timeInterval
                                    ? locale(`program.time.minutes`, {minutes: timeInterval})
                                    : locale('program.time.without.interval')
                                }
                            </option>
                        ))
                    }
                </FormControl>
            </FormGroup>
            <CPSettingToggle
                name={constants.SCHEDULE_TILE_SHOW_MEMBERS_PHOTO}
                isChecked={settings?.[constants.SCHEDULE_TILE_SHOW_MEMBERS_PHOTO]}
                label="Показывать фотографии участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_TILE_SHOW_MEMBERS_NAME}
                isChecked={settings?.[constants.SCHEDULE_TILE_SHOW_MEMBERS_NAME]}
                label="Показывать имена участников"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_TILE_SHOW_PARTICIPATION_TYPE}
                isChecked={settings?.[constants.SCHEDULE_TILE_SHOW_PARTICIPATION_TYPE]}
                label="Показывать формат"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_TILE_SHOW_STATUS}
                isChecked={settings?.[constants.SCHEDULE_TILE_SHOW_STATUS]}
                label="Показывать статус"
                onChange={onChange}
            />
            <CPSettingToggle
                name={constants.SCHEDULE_TILE_ADD_TO_CALENDAR}
                isChecked={settings?.[constants.SCHEDULE_TILE_ADD_TO_CALENDAR]}
                label="Показывать кнопку 'Добавить в календарь'"
                onChange={onChange}
            />
            <CPSettingSize
                name={constants.SCHEDULE_TILE_PHOTO_ROUNDING}
                label="Скругление фотографий в карточках"
                eventValue={settings?.[constants.SCHEDULE_TILE_PHOTO_ROUNDING]}
                defaultValue={'10px'}
                onChange={onChange}
            />
        </> 
    );
};

export default CardViewTile;
